import React from 'react';
import Head from 'next/head';

export function MetaCanonical(props: { href: string }) {
  return (
    <Head>
      <link key="canonical" rel="canonical" href={props.href} />
      <meta key="og:url" property="og:url" content={props.href} />
    </Head>
  );
}
